import { cva as t } from "class-variance-authority";
var i = t("", {
  variants: {
    size: {
      "caption-sm": "lib:text-caption-small-sm lib:md:text-caption-small-md lib:xl:text-caption-small-xl",
      "caption-lg": "lib:text-caption-large-sm lib:md:text-caption-large-md lib:xl:text-caption-large-xl",
      sm: "lib:text-small-sm lib:md:text-small-md lib:xl:text-small-xl",
      md: "lib:text-medium-sm lib:md:text-medium-md lib:xl:text-medium-xl",
      lg: "lib:text-large-sm lib:md:text-large-md lib:xl:text-large-xl",
      xl: "lib:text-big-sm lib:md:text-big-md lib:xl:text-big-xl"
    },
    color: {
      unset: "",
      dark: "lib:text-dark-90",
      white: "lib:text-white"
    },
    fontFamily: {
      cygre: "lib:font-cygre",
      aqum2: "lib:font-aqum2"
    },
    weight: {
      regular: "lib:font-normal",
      semibold: "lib:font-semibold",
      bold: "lib:font-bold"
    },
    align: {
      left: "lib:text-left",
      center: "lib:text-center",
      right: "lib:text-right",
      justify: "lib:text-justify"
    }
  },
  defaultVariants: {
    size: "md",
    color: "unset",
    weight: "regular",
    align: "left",
    fontFamily: "cygre"
  }
});
export {
  i as textVariants
};
